module.exports = __webpack_public_path__ + "img/add-departure-table-icon.51d4b9b3.svg";